import { required } from "@/utils/inputValidators";
import { StyledInputField } from "@/components/styledInputField/styledInputField";
import { UseFormReturn } from "react-hook-form";
import { IGiftCardFormFields } from "../types";
import { inputFieldTheme } from "../../../../utils/themes";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";
import { useTranslations } from "next-intl";
import { useId } from "react";

interface IRecipientName {
  label: string;
  placeholder: string;
  form?: UseFormReturn<IGiftCardFormFields>;
  isRequired: boolean;
  giftCardSellingEnabled: boolean;
  merchantColor?: string;
}

export const RecipientName = ({
  label,
  placeholder,
  form,
  isRequired,
  giftCardSellingEnabled,
  merchantColor,
}: IRecipientName) => {
  const t = useTranslations("GiftCard");
  const nameLabelId = useId();
  return (
    <div
      data-testid={applyDataTestId(pom.giftCard.recipientName)}
      className="w-full md:w-1/2"
    >
      <StyledInputField
        ariaLabelledby={nameLabelId}
        id={nameLabelId}
        theme={inputFieldTheme}
        className="[&_.MuiOutlinedInput-root]:bg-white"
        label={label}
        placeholder={placeholder}
        name="recipientName"
        type="text"
        form={form}
        validator={{
          required: isRequired ? required("name", t("pleaseFillOut")) : false,
        }}
        disabled={!giftCardSellingEnabled}
        merchantColor={merchantColor}
      />
    </div>
  );
};
